import 'twin.macro';
import styled from 'styled-components';
import Svg from './Svg';

const Icon = styled(Svg)<{ color?:string }>` 
  color: white;
  display: inline;
  stroke: ${({ color = '#CFD6DB' }) => color};
  fill: ${({ color = '#CFD6DB' }) => color};
  margin: -2px 0 0 8px;
`;

function ArrowUp({ color }:{ color?:string }) {
  return (
    <Icon color={color} width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4.6465 10.853C4.8415 11.048 5.1585 11.048 5.3535 10.853L8.9995 7.207L12.6455 10.853C12.8405 11.048 13.1575 11.048 13.3525 10.853C13.5475 10.658 13.5475 10.341 13.3525 10.146L9.3525 6.146C9.2545 6.048 9.1265 6 8.9985 6C8.8705 6 8.7425 6.049 8.6445 6.146L4.6445 10.146C4.4515 10.341 4.4515 10.657 4.6465 10.853Z" fill="#1381E0" />
    </Icon>
  );
}

export default ArrowUp;
